import * as queryString from "query-string";

export const parseSearch = (search: string) => queryString.parse(queryString.extract(search)) as Record<string, string | string[]>;
